export default __webpack_public_path__ + "static/FS2S-InHub-150-dbc21a3bc3f96781dff05e80477060b2.jpg";